import React from "react";
import PropTypes from "prop-types";

// Components
import SectionContainer from "core/SectionContainer";
import BodyText from "core/BodyText";
import TagToggle from "core/TagToggle";
import Campaigns from "./Campaigns";

// styles
import { OldGrid, Col, Row } from "core/oldGrid";
import colors from "core/colors";
import { AboutHeading, Description, UploadedDate } from "./styles";

const AboutThisImage = ({
    image,
    tags,
    createdAt,
    sectionHeading,
    sectionDataTestId,
    campaignLinkPrefix,
    campaigns,
    saveScroll,
    isIcons = false
}) => {
    // if no image, return early:
    if (!image) {
        return null;
    }

    const { description, id } = image;

    return (
        <SectionContainer
            topSpacing="4xl"
            bottomSpacing="4xl"
            bgColor={colors.primary.snow}
            data-testid={sectionDataTestId}
        >
            <OldGrid>
                <Row>
                    <Col sm={12} md={5}>
                        <AboutHeading
                            type="div"
                            size="xs"
                            headingColor={colors.secondary.orca}
                        >
                            {sectionHeading}
                        </AboutHeading>

                        {description && (
                            <Description>{description}</Description>
                        )}

                        <BodyText
                            type="div"
                            size="sm"
                            copyColor={colors.secondary.orca}
                        >
                            <div>Image# {id}</div>
                            {createdAt && (
                                <UploadedDate isIcons={isIcons}>
                                    Uploaded {createdAt}
                                </UploadedDate>
                            )}
                        </BodyText>

                        {campaigns && (
                            <Campaigns
                                campaignLinkPrefix={campaignLinkPrefix}
                                campaigns={campaigns}
                                saveScroll={saveScroll}
                            />
                        )}
                    </Col>
                    <Col sm={12} md={7}>
                        <TagToggle tags={tags} />
                    </Col>
                </Row>
            </OldGrid>
        </SectionContainer>
    );
};

AboutThisImage.propTypes = {
    sectionHeading: PropTypes.string,
    sectionDataTestId: PropTypes.string,
    createdAt: PropTypes.string,
    tags: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            slug: PropTypes.string,
            url: PropTypes.string
        })
    ),
    image: PropTypes.shape({
        id: PropTypes.string,
        description: PropTypes.string,
        createdAt: PropTypes.string
    }),
    campaignLinkPrefix: PropTypes.string,
    campaigns: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            slugWithId: PropTypes.string.isRequired
        })
    ),
    saveScroll: PropTypes.func,
    isIcons: PropTypes.bool
};
export default AboutThisImage;
